export type SourceFormat =
  | 'full_format'
  | 'web_cookies'
  | 'web_blocks'
  | 'web_json'
  | 'mobile'
  | 'pipe'
  | 'netscape'

export type TargetFormat = 'iam' | 'web' | 'custom'

export type AccountData = {
  login: string
  password: string
  twofaKey: string
  cookies: Record<string, string>
  userAgent: string
  proxy: string
  emailLogin: string
  emailPassword: string
  androidId: string
}

export function emptyAccount(): AccountData {
  return {
    login: '',
    password: '',
    twofaKey: '',
    cookies: {},
    userAgent: '',
    proxy: '',
    emailLogin: '',
    emailPassword: '',
    androidId: '',
  }
}

export type ErrorDetail = {
  index: number
  message: string
}

export type ParseStats = {
  total: number
  success: number
  errors: number
  errorDetails: ErrorDetail[]
}

export function emptyStats(): ParseStats {
  return { total: 0, success: 0, errors: 0, errorDetails: [] }
}
